const api = {
  //申请应用开发
  doadd: '/pgdp-icg/feedback/doadd',
  dologin: '/pgdp-icg/auth/login',
  domodifyPassword: '/pgdp-icg/api/user/updateUserPassword',

}

module.exports = api;


// WEBPACK FOOTER //
// ./src/store/api.js